var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V32H0z",
    transform: "translate(0 -168) translate(0 48) translate(0 8) translate(0 112)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.5H18V12h1.5c1.242.001 2.249 1.008 2.25 2.25v3h1.5v-3c-.002-2.07-1.68-3.748-3.75-3.75zM18 3c1.243 0 2.25 1.007 2.25 2.25S19.243 7.5 18 7.5s-2.25-1.007-2.25-2.25S16.757 3 18 3m0-1.5c-2.071 0-3.75 1.679-3.75 3.75C14.25 7.321 15.929 9 18 9c2.071 0 3.75-1.679 3.75-3.75 0-.995-.395-1.948-1.098-2.652C19.948 1.895 18.995 1.5 18 1.5zm-.75 21h-1.5V21c-.001-1.242-1.008-2.249-2.25-2.25h-3c-1.242.001-2.249 1.008-2.25 2.25v1.5h-1.5V21c.002-2.07 1.68-3.748 3.75-3.75h3c2.07.002 3.748 1.68 3.75 3.75v1.5zM12 9.75c1.243 0 2.25 1.007 2.25 2.25s-1.007 2.25-2.25 2.25S9.75 13.243 9.75 12 10.757 9.75 12 9.75m0-1.5c-2.071 0-3.75 1.679-3.75 3.75 0 2.071 1.679 3.75 3.75 3.75 2.071 0 3.75-1.679 3.75-3.75 0-.995-.395-1.948-1.098-2.652C13.948 8.645 12.995 8.25 12 8.25zM6 10.5H4.5c-2.07.002-3.748 1.68-3.75 3.75v3h1.5v-3c.001-1.242 1.008-2.249 2.25-2.25H6v-1.5zM6 3c1.243 0 2.25 1.007 2.25 2.25S7.243 7.5 6 7.5 3.75 6.493 3.75 5.25 4.757 3 6 3m0-1.5c-2.071 0-3.75 1.679-3.75 3.75C2.25 7.321 3.929 9 6 9c2.071 0 3.75-1.679 3.75-3.75 0-.995-.395-1.948-1.098-2.652C7.948 1.895 6.995 1.5 6 1.5z",
    transform: "translate(0 -168) translate(0 48) translate(0 8) translate(0 112) translate(16 16)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.d950e9e76071e2088bf0835f00d95aca.svg";
export { ForwardRef as ReactComponent };